import {
  CLEAR_ERRORS_ENGAGEMENTS_COMMENT,
} from 'pages/WirelineEngagements/WirelineEngagementsComments/ClearErrorsComments/actionTypes';

export const clearErrorsComment = (comments) => (
  { type: CLEAR_ERRORS_ENGAGEMENTS_COMMENT, comments });
